import PropTypes from 'prop-types';
import cc from 'classcat';

import { customThemes } from '../../../lib/themes';

import styles from './styles.module.scss';

const ChatBubble = ({ theme, className, onClick }) => (
  <svg
    role="img"
    viewBox="0 0 25 24"
    className={cc([className, styles.container])}
    onClick={onClick}
  >
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      opacity="0.587611607"
    >
      <g
        transform="translate(-71.000000, -557.000000)"
        className={styles[theme]}
      >
        <g transform="translate(71.000000, 558.000000)">
          <path d="M12.5,-0.475 C14.6166773,-0.475 16.5916575,-4.75e-06 18.425,0.95 C20.1916755,1.883338 21.5916615,3.149992 22.625,4.75 C23.691672,6.3833415 24.225,8.15832375 24.225,10.075 C24.225,11.9916762 23.691672,13.7666585 22.625,15.4 C21.5916615,17.000008 20.1916755,18.266662 18.425,19.2 C16.5916575,20.1500048 14.6166773,20.625 12.5,20.625 C11.299994,20.625 10.1166725,20.458335 8.95,20.125 L4.85,22.85 C4.649999,22.983334 4.44166775,22.9916673 4.225,22.875 C4.00833225,22.7583328 3.9,22.5750012 3.9,22.325 L4.2,17.5 C3.133328,16.566662 2.300003,15.4500065 1.7,14.15 C1.099997,12.8499935 0.79166675,11.4916738 0.775,10.075 C0.775,8.15832375 1.308328,6.3833415 2.375,4.75 C3.4083385,3.149992 4.8083245,1.883338 6.575,0.95 C8.4083425,-4.75e-06 10.3833228,-0.475 12.5,-0.475 Z" />
        </g>
      </g>
    </g>
  </svg>
);

ChatBubble.propTypes = {
  theme: PropTypes.oneOf(customThemes('dark', 'light')),
  className: PropTypes.string,
  onClick: PropTypes.func,
};

ChatBubble.defaultProps = {
  theme: 'dark',
};

export default ChatBubble;
